import React, { useEffect, useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Autocomplete, FormControl, TextField } from '@mui/material';
import { fetchOptions } from '../queries';

const Bays = ({ name, props, query, filterKey }) => {
    const {
        clearErrors,
        control,
        formState: { errors },
        getValues,
        setError,
    } = useFormContext();
    const [options, setOptions] = useState([]);
    const { label } = props;

    useEffect(() => {
        const fetchBays = async () => {
            const { endpoint } = query || {};
            const where = {};
            if (filterKey) {
                where[filterKey] = getValues(filterKey);
            }
            const optionsResponse = await fetchOptions({ endpoint, where });

            if (optionsResponse.error) {
                setOptions([]);
                setError(name, { type: 'fetch options', message: `Could not fetch ${label} options` });
            } else {
                setOptions(optionsResponse);
                clearErrors([name]);
            }
        };
        fetchBays();
    }, [filterKey]);

    const getOptionLabel = (option) => {
        if (option?.name) return option.name;
        const foundOption = options.find((opt) => opt._id === (option?._id ?? option));
        return foundOption?.name ?? '';
    };

    const renderInput = (inputProps) => (
        <TextField
            {...inputProps}
            label={label}
            variant="outlined"
            error={errors[name]}
            helperText={errors[name]?.message}
            // wrap
        />
    );

    if (!options.length && !errors[name]) {
        return (
            <TextField
                value="Loading options"
                disabled
                label={label}
                variant="outlined"
                sx={{ width: '100%' }}
                // wrap
            />
        );
    }

    return (
        <FormControl fullWidth style={{ margin: '8px 0' }}>
            <Controller
                control={control}
                name={name}
                render={({ field: { onChange, value } }) => (
                    <Autocomplete
                        value={value ?? []}
                        onChange={(_e, item) => {
                            const mappedItem = item.map((i) => i.id ?? i._id ?? i);
                            onChange(mappedItem);
                        }}
                        options={options}
                        renderInput={renderInput}
                        getOptionLabel={getOptionLabel}
                        isOptionEqualToValue={(option, val) => {
                            const valId = val?.id || val?._id || val;
                            const optionId = option?.id || option?._id || option;
                            return valId === optionId;
                        }}
                        multiple
                        {...props}
                        // wrap
                    />
                )}
            />
        </FormControl>
    );
};

export default Bays;
